import messages from './onboarding.json' with { type: 'json' };

export const onboardingFi: Readonly<typeof messages> = messages;
